/**
 * Collapsible title/body accordion used in the service detail hero
 * (What to Expect / How to Prep). Matches the Figma styling: Euclid Semibold title,
 * a rotating chevron, and a bottom hairline border.
 */
/* eslint-disable @next/next/no-img-element */
import React, { useId, useState } from 'react'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'
import { mq } from '../../helpers'

/**
 * @param {{ title: string, defaultOpen?: boolean, children: React.ReactNode, onOpen?: () => void }} props
 */
const Accordion = ({ title, defaultOpen = false, children, onOpen }) => {
  const [open, setOpen] = useState(defaultOpen)
  const panelId = useId()
  return (
    <Wrapper>
      <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => {
        setOpen(!open)
        if (!open) {
          onOpen?.()
        }
      }}>
        <span>{title}</span>
        <img
          className={open ? 'chevron open' : 'chevron'}
          src="/images/nav-arrow-down.svg"
          alt=""
          aria-hidden="true"
          width={24}
          height={18}
        />
      </button>
      {open && <div className="body" id={panelId}>{children}</div>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  border-bottom: 1px solid ${c.sand};
  padding: 24px 0;

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: Euclid;
    font-size: 18px;
    font-weight: 600;
    color: ${c.black};
    text-align: left;
  }

  .chevron {
    flex-shrink: 0;
    transition: transform 0.2s ease;
    transform: rotate(180deg);
  }
  .chevron.open {
    transform: rotate(0deg);
  }

  .body {
    margin-top: 12px;
    font-family: Euclid;
    font-size: 16px;
    line-height: 24px;
    color: ${c.darkGrey};

    ${mq('max', '900px')} {
      font-size: 15px;
    }
  }
`

export default Accordion
